import type { ReactNode } from 'react';

import { richTextToReactNode } from '@seuk/cms-api-client';
import { deserializeCardInterface } from '@seuk/cms-mappers';
import { EMarketingSectionType } from '@seuk/cms-mappers/enum';
import type { MarketingSectionData } from '@seuk/cms-mappers/serializers';
import { SectionGroup } from '@seuk/design-system/atoms';
import { FAQList, MarketingCards, MarketingProductsCards, TextSection } from '@seuk/design-system/organisms';

function getContent(section: MarketingSectionData): ReactNode | undefined {
  switch (section.type) {
    case EMarketingSectionType.TextSection:
      return <TextSection {...section.props} description={richTextToReactNode(section.props.description)} />;

    case EMarketingSectionType.InformationalCardListSection:
      return <MarketingCards {...section.props} cards={section.props.cards.map(deserializeCardInterface)} />;

    case EMarketingSectionType.ProductsCardListSection:
      return <MarketingProductsCards {...section.props} cards={section.props.cards.map(deserializeCardInterface)} />;

    case EMarketingSectionType.GroupSection:
      return (
        <SectionGroup spacing={section.props.itemsSpacing}>
          {section.props.items.map((item) => (
            <div key={`${item.id}`}>{getContent(item)}</div>
          ))}
        </SectionGroup>
      );

    case EMarketingSectionType.FAQListSection:
      return <FAQList {...section.props} />;

    default:
      return <></>;
  }
}

export const ArticleSection = (section: MarketingSectionData) => {
  return <>{getContent(section)}</>;
};
